import React from 'react';
import PropTypes from 'prop-types';

// react-markdown 5.x ships an older micromark that crashes on some edge-case markdown inputs.
// This boundary lets the offending block fall back to its raw text while the rest of the
// transcript keeps rendering. `renderFallback` customizes the fallback element (MessageBubble
// wraps it in a styled <pre>); by default the raw text renders bare.
class MarkdownSafeBoundary extends React.Component {
  state = { failed: false };
  static getDerivedStateFromError() { return { failed: true }; }
  componentDidCatch(err) { console.error('[AP] markdown render failed:', err); }
  // Streaming re-renders the same block with growing text; react-markdown can throw on
  // transiently-incomplete markdown (an unclosed **, a half-written table row). With
  // `recoversOnTextChange`, the boundary retries when the text changes so a momentary failure
  // mid-stream doesn't latch the fallback for the rest of the turn once valid markdown arrives.
  componentDidUpdate(prevProps) {
    if (this.props.recoversOnTextChange && this.state.failed && prevProps.text !== this.props.text) {
      this.setState({ failed: false });
    }
  }
  render() {
    if (this.state.failed) {
      return this.props.renderFallback ? this.props.renderFallback(this.props.text) : this.props.text;
    }
    return this.props.children;
  }
}

MarkdownSafeBoundary.propTypes = {
  text: PropTypes.string,
  recoversOnTextChange: PropTypes.bool,
  renderFallback: PropTypes.func,
  children: PropTypes.node
};

export default MarkdownSafeBoundary;
